/* eslint-disable max-lines-per-function */

import { InputText, Modal } from "@bluframe/blublocks"
import ActionsAndInfoSideBar from "components/ActionsAndInfoSideBar"
import ConfirmModal from "components/ConfirmModal"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"
import Select from "components/inputs/Select"
import { Form, Main, Top } from "components/List/ItemView/styled"

import { ComponentProps } from "."

const Item = ({
  actionButtonLabel,
  actionButtonOnClick,
  isActionButtonLoading,
  isAdd,
  isAdmin,
  isEditMode,
  isEditor,
  isModalOpen,
  isVendorsSuggestionsLoading,
  item,
  modalContent,
  onGetVendorsSuggestions,
  onModalClose,
  onModalConfirmOpen,
  onModalDeleteConfirm,
  onModalPublishToggleConfirm,
  onSelectVendorId,
  onSubmit,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  urlRef,
  selectedVendorId,
  statusRef,
  statuses,
  vendors
}: ComponentProps) => (
  <Form onSubmit={onSubmit}>
    <Top>
      <Main>
        {item?.id ? (
          <FieldLabelAndValue>
            <FieldLabel>{"ID"}</FieldLabel>

            <FieldValue>{item.id}</FieldValue>
          </FieldLabelAndValue>
        ) : null}

        <FieldRow $items={2}>
          {isEditMode ? (
            <InputText
              defaultValue={item?.url}
              inputId="url"
              label="Url"
              name="url"
              ref={urlRef}
              required
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Url"}</FieldLabel>

              <FieldValue>{item?.url}</FieldValue>
            </FieldLabelAndValue>
          )}

          {isEditMode ? (
            <Select
              defaultValue={item?.status}
              label="Status"
              name="status"
              options={statuses}
              placeholder="Select Status"
              ref={statusRef}
              required
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Status"}</FieldLabel>

              <FieldValue>{item?.status}</FieldValue>
            </FieldLabelAndValue>
          )}
        </FieldRow>
      </Main>

      <ActionsAndInfoSideBar
        actionButtonLabel={actionButtonLabel}
        actionButtonOnClick={actionButtonOnClick}
        isActionButtonLoading={isActionButtonLoading}
        isAdd={isAdd}
        isAdmin={isAdmin}
        isEditMode={isEditMode}
        isEditor={isEditor}
        isLinkedItemsSuggestionsLoading={isVendorsSuggestionsLoading}
        item={
          item
            ? {
                createdAt: item.createdAt,
                isPublished: item.isPublished,
                linkedItem: item.vendor
                  ? { id: item.vendor.id, name: item.vendor.name }
                  : undefined,
                publishedAt: item.publishedAt,
                updatedAt: item.updatedAt
              }
            : undefined
        }
        linkedItemLabel="Vendor"
        linkedItemPath="/vendors/vendors"
        linkedItems={vendors}
        linkedItemsSearchLabel="Search for a Vendor"
        onGetLinkedItemsSuggestions={onGetVendorsSuggestions}
        onModalConfirmOpen={onModalConfirmOpen}
        onSelectLinkedItemId={onSelectVendorId}
        outlinedButtonLabel={outlinedButtonLabel}
        outlinedButtonOnClick={outlinedButtonOnClick}
        selectedLinkedItemId={selectedVendorId}
      />
    </Top>

    <Modal isOpen={isModalOpen} onClose={onModalClose}>
      {modalContent === "deleteConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to delete?`}
          onClose={onModalClose}
          onConfirm={onModalDeleteConfirm}
        />
      )}

      {modalContent === "publishConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to ${
            item?.isPublished ? "unpublish" : "publish"
          }?`}
          onClose={onModalClose}
          onConfirm={onModalPublishToggleConfirm}
        />
      )}
    </Modal>
  </Form>
)

export default Item
